import React from 'react';

export interface LegacyStoryProps {
  content: string;
}

const LegacyStory: React.FC<LegacyStoryProps> = ({ content }) => {
  return (
    <blockquote>
      <p className='candidate-story-legacy-content'>{content}</p>
    </blockquote>
  );
};

export default LegacyStory;
